<script>
	import { onMount } from 'svelte'
    import { FormationsData, BrillianceData } from '../../script/_data'
    import { GetMonsterName } from '../../script/_monster'

    export let Device, Formation, Brilliance
    let txtBrilliance = ['탄창', '비탄창', '가호', '재능', '강림']

    let leftHeight, rightHeight, barHeight = 0
    $:  if(Device == 3) {barHeight=1}
        else if(leftHeight>rightHeight) {barHeight=leftHeight-100}
        else {barHeight=rightHeight-100}
</script>

<div class='formation' bind:clientHeight={leftHeight}>
    {#if Formation.num >= 1}
        <div class="left">
            <img
                src="../img/formation/{Formation.num}.png"
                alt="formation_{Formation.num}"
            >
            <div class="name">{FormationsData[(Formation.num-1)].name} 대형</div>
        </div>

        <div class="right">
            {#each Formation.data as item, i}
                <div class="row">
                    {(i+1)}:{GetMonsterName(item)}
                </div>
            {/each}
        </div>
    {:else}
        <div class="name none">등록된 대형이 없습니다.</div>
    {/if}
</div>

<div class="bar" style="height:{barHeight}px;"></div>

<div class='brilliance' bind:clientHeight={rightHeight}>
    {#each txtBrilliance as txt, i}
        <div class="row">
            <div class="tag">{txt} : </div>
            {#if Brilliance[i] > 0}
                {BrillianceData[(Brilliance[i]-1)].name}
            {:else}
                비어있음
            {/if}
        </div>
    {/each}
</div>

<style lang="scss">
    .formation {
        width: calc(50% - 70px);
        height: fit-content;
        padding: 50px;
        padding-left: 20px;
        display: inline-block;
        vertical-align: top;

        .left {
            width: calc(30%);
            text-align: center;
            display: inline-block;
            vertical-align: top;

            .name {
                color: $cl3;
                font-size: 15px;
                font-family: aggro;
            }

            img { width: 100%; margin-bottom: 10px;}
        }
        .right {
            width: calc(70% - 24px);
            margin-left: 24px;
            display: inline-block;
            vertical-align: top;

            .row {
                width: fit-content;
                height: fit-content;
                margin: 10px 5px;
                font-size: 15px;
                font-weight: 400;
            }
        }
    }

    .bar {
            content: "";
            background: $cl3;
            width: 1px;
            margin: 50px 0;
            display: inline-block;
    }

    .brilliance {
        width: calc(50% - 1px - 100px);
        height: fit-content;
        padding: 50px;
        display: inline-block;
        vertical-align: top;

        .row {
            width: fit-content;
            height: fit-content;
            margin: 15px 0;
            font-size: 15px;
            font-weight: 400;

            .tag { color: $cl3; font-family: aggro; display: inline-block; }
        }
    }

    .none {
        color: $cl4;
        font-size: 16px;
        font-family: aggro;
    }

    @include mobile {
        .formation {
            width: calc(100% - 40px);
            padding: 20px;
            display: block;
        }

        .bar {
            display: block;
            width: calc(100% - 40px);
            margin: 0 20px;
            height: 0;
        }

        .brilliance {
            width: calc(100% - 40px);
            padding: 20px;
            display: block;
            .row { margin: 10px 0; }
        }
    }
</style>